import React from 'react';
import { Tooltip } from './Tooltip';

const InputField = ({ label, value, onChange, tooltipImageSrc, tooltipText, disabled }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mt-1 mb-1 items-center">
      <span>{label}</span>
      {tooltipImageSrc && tooltipText && (
        <Tooltip
          content={
            <div className="flex flex-col items-center">
              <img
                src={tooltipImageSrc}
                alt="説明画像"
                loading="lazy"
                className="mb-2 w-32 rounded object-contain"
              />
              <p>{tooltipText}</p>
            </div>
          }
        >
          <span className="ml-1 text-blue-500 cursor-pointer">ⓘ</span>
        </Tooltip>
      )}
    </label>
    <input
      type="number"
      step="any"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`w-full border border-blue-200 focus:border-blue-500 focus:ring-blue-500 rounded px-2 py-1 ${
        disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''
      }`}
    />
  </div>
);

export default InputField;
